/**
 * Created by Administrator on 2017/4/27.
 */

export default {
  changeParamValue(url, key, value) {
    const pattern = `${key}=([^&]*)`;
    const replaceText = `${key}=${value}`;
    if (url.match(pattern)) {
      let tmp = `/(${key}=)([^&]*)/gi`;
      tmp = url.replace(eval(tmp), replaceText);
      return tmp;
    }
    if (url.match('[\\?]')) {
      return `${url}&${replaceText}`;
    }
    return `${url}?${replaceText}`;

    // return `${url}\n${key}\n${value}`;
  },

  join(url, query) {
    for (const key in query) {
      if (url.charAt(url.length - 1) === '/') {
        url += `?${key}=${query[key]}`;
      } else {
        url += `&${key}=${query[key]}`;
      }
    }
    return url;
  },

  queryString(query) {
    return Object.keys(query)
      .map((v) => `${v}=${query[v]}`)
      .join('&');
  },
};
